/**
 * @name FileUploadBox.js
 * @author 김권영
 * @since 2025. 01. 06.
 * @description
 * 공통 파일 목록 및 다운로드 삭제 기능
 * 
 * @param {number}   maxFileCount      1 => 단일, 그 이상 => 다중
 * @param {File[]}   selectedFiles     이미 선택된 새 파일들 (부모가 관리하는 state)
 * @param {function} setSelectedFiles  새 파일 배열 setter
 * @param {number}   existingFilesCount 기존 파일(삭제 예정 아닌) 개수
 * @param {array}    deletedFileSns    삭제 예정 fileSn 배열
 */
import React from "react";
import './FileList.css';
import { toast } from 'react-toastify';
function FileUploadBox({
  maxFileCount = 1, 
  selectedFiles = [],
  setSelectedFiles,
  existingFilesCount = 0,
  deletedFileSns = [],
}) {
  const isSingle = maxFileCount === 1;

  const handleFileChange = (e) => {
    const newSelected = Array.from(e.target.files);
    if (newSelected.length === 0) return;

    // 남아있는 기존 파일 수 (삭제 예정이 아닌)
    const remainExistingCount = existingFilesCount - deletedFileSns.length;
    // 이미 선택된 새 파일 개수
    const currentNewCount = selectedFiles.length;
    // 이번에 추가되는 파일 개수
    const addCount = newSelected.length;

    const totalAfterAdd = remainExistingCount + currentNewCount + addCount;


    if (totalAfterAdd > maxFileCount) {
      toast.warn(`파일은 최대 ${maxFileCount}개까지 첨부 가능합니다. (이미 ${remainExistingCount}개 등록됨, 새로 ${currentNewCount}개 선택됨)`);
      e.target.value = "";
      return;
    }

    if (isSingle) {
      // 단일 파일 -> 기존 선택 지우고 새 파일 1개만
      setSelectedFiles(newSelected.slice(0, 1));
      // 파일명 표시
      const fileName = newSelected[0]?.name || "";
      const labelInput = document.getElementById("LAW_FILE1");
      if (labelInput) labelInput.value = fileName;
    } else {
      // 다중 파일
      setSelectedFiles((prev) => [...prev, ...newSelected]);
    }

    e.target.value = "";
  };

  // (단일) X 클릭 시
  const removeSingleFile = () => {
    if (window.confirm("이 파일을 제거하시겠습니까?")) {
      setSelectedFiles([]);
      const labelInput = document.getElementById("LAW_FILE1");
      if (labelInput) labelInput.value = "";
    }
  };

  // (다중) X 클릭 시
  const removeFileAtIndex = (idx) => {
    setSelectedFiles((prev) => {
      const clone = [...prev];
      clone.splice(idx, 1);
      return clone;
    });
  };

  return (
    <fieldset>
      <div className="file-box">
        <input type="hidden" id="SEQ_NO1" value="" />
        <label htmlFor="LAW_FILE1" className="hide">
          첨부
        </label>

        {/* 파일명 표시용 (단일) */}
        <input
          type="text"
          id="LAW_FILE1"
          className="upload-nm"
          placeholder="파일선택"
          disabled
        />

        {/* 버튼 모양의 label */}
        <label htmlFor="LAW_FILE_PS1" className="file-nm">
          파일선택
        </label>
        <input
          type="file"
          id="LAW_FILE_PS1"
          name="files"
          className="upload-hd"
          style={{ display: "none" }}
          onChange={handleFileChange}
          multiple={!isSingle} // 다중이면 true
        />
      </div>

      {isSingle ? (
        // 단일 파일 모드
        selectedFiles.length > 0 && (
          <div>
            {selectedFiles[0].name}
            <button
              type="button"
              className="file-delete-button"
              style={{padding: '0px 0px 0px 10px'}}
              onClick={removeSingleFile}
            >
              X
            </button>
          </div>
        )
      ) : (
        // 다중 파일 모드
        selectedFiles.length > 0 && (
          <ul style={{ marginTop: 3, padding:"0px" }}>
            {selectedFiles.map((file, idx) => (
              <li key={idx}>
                {file.name}
                <button
                  type="button"
                  className="file-delete-button"
                  style={{padding: '0px 0px 0px 10px'}}
                  onClick={() => removeFileAtIndex(idx)}
                >
                  X
                </button>
              </li>
            ))}
          </ul>
        )
      )}
    </fieldset>
  );
}

export default FileUploadBox;
